import React from "react";
import { FormattedMoney } from "../../Common/Helpers/MoneyHelper";
import TitleValueCell from "./TitleValueCell";
import { Money } from "../../Common/Types";

interface TitleValueCellProps {
  title: string;
  discount?: Money;
}

export const DiscountTitleValueCell: React.FC<TitleValueCellProps> = ({ title, discount }) => {
  if (!discount || !discount.amount) return null;
  return (
    <TitleValueCell
      leftTextValue={title}
      rightTextValue={FormattedMoney(discount!)}
      options={{ rightTextClassName: "whitespace-nowrap" }}
      className="flex w-full justify-between gap-1 text-success"
      testId="psc-total"
    />
  );
};

export default TitleValueCell;
